import type { MobileTheme } from '@/components/mobile_preview/constants';

/** Replica colors of the app's ranking card — mobile-surface hex exemption. */
export const RANKING_CARD_SURFACE: Record<MobileTheme, string> = {
  light: '#FFFFFF',
  dark: '#2E2E2E',
};

/** The big position numeral, drawn over the cover's corner; fill and
 * edge swap with the phone theme so it reads against any artwork. */
export const RANKING_NUMERAL_FILL: Record<MobileTheme, string> = {
  light: '#FFFFFF',
  dark: '#111111',
};
export const RANKING_NUMERAL_STROKE: Record<MobileTheme, string> = {
  light: '#111111',
  dark: '#FFFFFF',
};

export const RANKING_MUTED_TEXT: Record<MobileTheme, string> = {
  light: '#6B6560',
  dark: '#A8A8A8',
};
